export enum AuthUserType {
    // individual free user
    Free = 'free',
    // individual premium account
    Premium = 'premium',
    // team account
    Team = 'team'
}